import { __spreadArray, __awaiter, __generator, __assign } from 'tslib';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { magic } from '@gig/magic-sdk';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';

var _a;
var TRANSACTIONS_NAMESPACE = 'TRANSACTIONS_NAMESPACE';
var CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';
var SET_TRANSACTIONS = 'SET_TRANSACTIONS';
var SET_IS_LOADING_STATE = 'SET_IS_LOADING_STATE';
var APPEND_TRANSACTIONS = 'APPEND_TRANSACTIONS';
var getters = {
    getPurchaseTransactions: function (state) {
        return __spreadArray(__spreadArray([], state.monetary.transactions.filter(hasSweepxData)), state.adjustment.transactions.filter(function (t) {
            try {
                var currency = t.Payload.CurrencyCode;
                return ((hasSweepxData(t) ||
                    currency === Currency.GLD ||
                    currency === Currency.SWP) &&
                    !(isMagicAdjustment(t) && currency === Currency.GLD));
            }
            catch (_a) {
                return false;
            }
        })).sort(function (a, b) { return b.TimestampEpoch - a.TimestampEpoch; });
    },
    getRedemptionTransactions: function (state) {
        return __spreadArray(__spreadArray([], state.monetary.transactions), state.adjustment.transactions.filter(function (t) { return !getPaymentMethod(t).toLowerCase().includes('manual'); })).sort(function (a, b) { return b.TimestampEpoch - a.TimestampEpoch; });
    },
    hasMoreRows: function (state) {
        return (hasMoreEntries(state, 'monetary') ||
            hasMoreEntries(state, 'adjustment'));
    },
    isLoadingState: function (state) {
        return state.isLoading;
    },
};
var actions = {
    fetchTransactions: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var from = _b.from, to = _b.to, size = _b.size, typeFilter = _b.typeFilter, _c = _b.loadMore, loadMore = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var mutationType, starting, params, _d, monetary, adjustment, e_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        commit(SET_IS_LOADING_STATE, true);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        mutationType = loadMore
                            ? APPEND_TRANSACTIONS
                            : SET_TRANSACTIONS;
                        if (!loadMore) {
                            commit(CLEAR_TRANSACTIONS);
                        }
                        starting = loadMore ? state.starting : 0;
                        params = {
                            size: size,
                            from: starting,
                            dateFrom: from.toISOString(),
                            dateTo: to.toISOString(),
                            operationType: typeFilter,
                        };
                        return [4 /*yield*/, Promise.all([
                                hasMoreEntries(state, 'monetary')
                                    ? magic.methods.users.getSweepxTransactionsHistory(__assign(__assign({}, params), { mediatorType: CoreXMediatorType.MONETARY }))
                                    : Promise.resolve({}),
                                hasMoreEntries(state, 'adjustment')
                                    ? magic.methods.users.getSweepxTransactionsHistory(__assign(__assign({}, params), { mediatorType: CoreXMediatorType.MONETARY_ADJUSTMENT }))
                                    : Promise.resolve({}),
                            ])];
                    case 2:
                        _d = _e.sent(), monetary = _d[0], adjustment = _d[1];
                        commit(mutationType, {
                            monetary: monetary,
                            adjustment: adjustment,
                            starting: starting + size,
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _e.sent();
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        commit(SET_IS_LOADING_STATE, false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
};
var transactions = {
    namespaced: true,
    state: {
        monetary: {
            transactions: [],
            total: 0,
        },
        adjustment: {
            transactions: [],
            total: 0,
        },
        starting: 0,
        isLoading: true,
    },
    getters: getters,
    actions: actions,
    mutations: (_a = {},
        _a[CLEAR_TRANSACTIONS] = function (state) {
            state.monetary = {
                transactions: [],
                total: 0,
            };
            state.adjustment = {
                transactions: [],
                total: 0,
            };
            state.starting = 0;
        },
        _a[SET_TRANSACTIONS] = function (state, payload) {
            setState(state, 'monetary', payload.monetary);
            setState(state, 'adjustment', payload.adjustment);
            state.starting = payload.starting;
        },
        _a[APPEND_TRANSACTIONS] = function (state, payload) {
            appendState(state, 'monetary', payload.monetary);
            appendState(state, 'adjustment', payload.adjustment);
            state.starting = payload.starting;
        },
        _a[SET_IS_LOADING_STATE] = function (state, payload) {
            state.isLoading = payload;
        },
        _a),
};
function setState(state, entry, response) {
    var _a, _b;
    state[entry].transactions = (_a = response === null || response === void 0 ? void 0 : response.ActivityUserWalletTransactions) !== null && _a !== void 0 ? _a : [];
    state[entry].total = (_b = response === null || response === void 0 ? void 0 : response.Total) !== null && _b !== void 0 ? _b : 0;
}
function appendState(state, entry, response) {
    if (response === null || response === void 0 ? void 0 : response.ActivityUserWalletTransactions) {
        state[entry].transactions = (state[entry].transactions || []).concat(response.ActivityUserWalletTransactions);
        state[entry].total = response.Total;
    }
}
function hasMoreEntries(state, entry) {
    return !state.starting || state.starting < state[entry].total;
}
function getSweepxData(t) {
    try {
        return getData(t).SweepStakesShop;
    }
    catch (_a) {
        return null;
    }
}
function getPaymentMethod(t) {
    try {
        return getData(t).PaymentMethod;
    }
    catch (_a) {
        return '';
    }
}
function hasSweepxData(t) {
    return !!getSweepxData(t);
}
function isMagicAdjustment(t) {
    try {
        return getData(t).Reason.toLowerCase().includes('magic');
    }
    catch (_a) {
        return false;
    }
}
function getData(t) {
    return JSON.parse(t.Payload.Transaction.Current.AdditionalProperties)
        .Payments.Transaction;
}

export { TRANSACTIONS_NAMESPACE, actions, getPaymentMethod, getSweepxData, getters, transactions };
